import { useQuery } from "@tanstack/react-query"
import { api } from "../api"


export const useQueryListToSelect = (url: string) => {

  const { data: list, isLoading, refetch } = useQuery({
    queryKey: ['query-list', url],
    queryFn: () => api.get(url),
    select: (data) =>
      data.data.map(
        (menu: { id: number, nome: string, descricao: string }) => ({
          label: menu.nome || menu.descricao,
          value: menu.id,
          ...menu
        })
      )
  })

  return {
    list,
    isLoading,
    refetch
  }
}
